module.exports = __webpack_public_path__ + "img/pump-green.6802d044.png";